module.exports = __webpack_public_path__ + "static/media/ts12cr1023.320cd3cd.png";